'use strict'

export const state = {
  Modal: {},
  Loader: {}
}



// WEBPACK FOOTER //
// ./src/store/state.js